import { MoneyFormatFilter } from '@/models/filters/money';
import { formatUnixDateFilter } from '@/models/filters/datetime';

export const ViewFiltersMixin = {
  filters: {
    money: MoneyFormatFilter,
    unixtime: formatUnixDateFilter,
  },
};
